/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents an object to wrapp sent email detail.
 */
export interface SentEmailDetailModel { 
    logId: number;
    recipientEmail: string;
    senderEmail: string;
    sentAtUtc: string;
    subject: string;
    body: string;
}

